import { z } from 'zod';
import { correo, opcional, ruc, uuid } from './comunes.js';
/**
 * Empresa emisora. SERKAT opera con dos razones sociales, así que el emisor
 * se elige por documento y sus datos ya no están escritos en la plantilla.
 */
export const empresaEntrada = z.object({
    codigo: z.string().trim().min(2).max(20),
    razonSocial: z.string().trim().min(3, 'La razón social es obligatoria').max(250),
    ruc,
    direccion: opcional(z.string().trim().max(300)),
    telefono: opcional(z.string().trim().max(30)),
    correo: opcional(correo),
    // Rellenan los marcadores de las cláusulas contractuales de LOG-FT-02
    urlCodigoEtica: opcional(z.url({ message: 'URL inválida' }).max(300)),
    correoDenuncias: opcional(correo),
    activa: z.boolean().default(true),
});
/**
 * `.partial()` hace opcionales los campos pero NO elimina sus `.default()`.
 *
 * Un PATCH con solo la dirección llegaba al servicio con `{ activa: true }`
 * inyectado: editar cualquier dato reactivaba una empresa dada de baja.
 */
export const empresaEdicion = empresaEntrada.partial().extend({
    activa: z.boolean().optional(),
});
export const empresa = z.object({
    id: z.number().int(),
    codigo: z.string(),
    razonSocial: z.string(),
    ruc: z.string(),
    direccion: z.string().nullable(),
    telefono: z.string().nullable(),
    correo: z.string().nullable(),
    urlCodigoEtica: z.string().nullable(),
    correoDenuncias: z.string().nullable(),
    activa: z.boolean(),
});
/** Cabecera de numeración común a todo documento emitido. */
export const numeracion = z.object({
    empresaId: z.number().int().positive(),
    correlativo: z
        .number()
        .int()
        .min(1, 'El correlativo debe ser mayor a cero')
        .max(999_999),
});
/**
 * `empresas.id` es smallserial. Sin el tope, un identificador mayor llegaba a
 * PostgreSQL y reventaba con «smallint out of range»: la aplicación devolvía
 * 500 donde correspondía un rechazo de validación.
 */
export const idEmpresa = z.object({
    id: z.coerce.number().int().positive().max(32767, 'Identificador fuera de rango'),
});
export const idDocumento = z.object({ id: uuid });
//# sourceMappingURL=empresa.js.map